module.exports = __webpack_public_path__ + "static/img/ht1.fea93f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ht1.jpg
// module id = 9XV8
// module chunks = 1